module.exports = __webpack_public_path__ + "img/24.e85bc228.jpg";